import { render, staticRenderFns } from "./WangZhanInfo.vue?vue&type=template&id=a3484250&scoped=true"
import script from "./WangZhanInfo.vue?vue&type=script&lang=js"
export * from "./WangZhanInfo.vue?vue&type=script&lang=js"
import style0 from "./WangZhanInfo.vue?vue&type=style&index=0&id=a3484250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3484250",
  null
  
)

export default component.exports